export const LOGIN_INFO_EVENT_NAME = 'login_info_event_name';

// 按钮 加入群聊 IM入群弹窗业务code
export const MARKETING_JOIN_CHAT_GROUP_BUSINESS_CODE = '1.10';

// 按钮 加入群聊 埋点上报链接
export const JOIN_CHAT_GROUP_TRACK_LINK = 'socialMediaMarketing';

// 按钮 跳转目标 注意: B端新增类型时需要更新！
const H5_CODE = 'h5';
const APP_CODE = 'app';
export const JOIN_CHAT_GROUP = 'join_chat_group';
const MP_CODE = 'mp';
const CUSTOMER_SERVICE_CODE = 'customer service';
const BUY_CODE = 1;
const NOW_CODE = 2;
const NIO_CODE = 3;
const CUSTOM_CODE = 4;
export const DMP_LINK_TYPE_MAP = {
    [H5_CODE]: {
        name: 'H5链接',
        subTypes: {
            [BUY_CODE]: '购车选配',
            [NIO_CODE]: 'NIOAPP下载页面',
            [CUSTOM_CODE]: '自定义链接'
        }
    },
    [APP_CODE]: {
        name: 'APP内页面',
        subTypes: {
            [CUSTOM_CODE]: '自定义APP页面'
        }
    },
    [JOIN_CHAT_GROUP]: {
        name: '加入群聊'
    },
    [MP_CODE]: {
        name: '小程序其他页面',
        subTypes: {
            [BUY_CODE]: '购车选配',
            [NOW_CODE]: '社区此刻',
            [CUSTOM_CODE]: '自定义链接'
        }
    },
    [CUSTOMER_SERVICE_CODE]: { name: '客服链接' }
};



// WEBPACK FOOTER //
// ./src/views/marketing/config.js